import React from 'react';
import Sidebar from '../Dashboard/Sidebar';
import TopBar from '../Dashboard/TopBar';
import Breadcrumbs from '../components/Breadcrumbs';
import { User } from '../types/user';

interface MainLayoutProps {
  user?: User | null;
  currentPath: string;
  onNavigate: (routeId: string, params?: Record<string, string>, data?: Record<string, any>) => void;
  onLogout: () => void;
  children: React.ReactNode;
  contextData?: Record<string, any>;
}

const MainLayout: React.FC<MainLayoutProps> = ({ 
  user, 
  currentPath,
  onNavigate,
  onLogout, 
  children,
  contextData = {}
}) => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar 
        currentPath={currentPath}
        onNavigate={onNavigate}
        onLogout={onLogout}
      />
      
      <div style={{ 
        flex: 1, 
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#f9fafb',
        overflow: 'hidden'
      }}>
        <TopBar />

        <div style={{ 
          flex: 1,
          padding: '15px 25px',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}>
          {/* Breadcrumbs */}
          <Breadcrumbs 
            currentPath={currentPath}
            onNavigate={onNavigate}
            contextData={contextData}
          />
          
          {/* Main Content */}
          <div style={{ marginTop: '20px' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;